import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createSpecMedicalEval = (payload) => post(baseURL + url.SPEC_MEDICAL_EVAL, payload);
export const getSpecMedicalEvalDetails = (id) => get(`${baseURL + url.SPEC_MEDICAL_EVAL}/${id}`);
export const updateSpecMedicalEval = (id, payload) => put(`${baseURL + url.SPEC_MEDICAL_EVAL}/${id}`, payload);
export const deleteSpecMedicalEval = (id) => remove(`${baseURL + url.SPEC_MEDICAL_EVAL}/${id}`);
